export const sizes = {
  container: {
    lg: '1216px',
  },
};
